const actions = {
  SET_DASHBOARD: 'layout/SET_DASHBOARD',
  SET_FOOTER: 'layout/SET_FOOTER',
  SET_SIDEBAR: 'layout/SET_SIDEBAR',
  SET_TOPBAR: 'layout/SET_TOPBAR',
};

export default actions;
